var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-collapsable"},[_c('header',{staticClass:"row-collapsable__header",attrs:{"data-testid":"row-collapsable-header"}},[_vm._t("rowCollapsableHeader")],2),_c('div',{ref:"tableContainer",class:[
				'row-collapsable__table',
				_vm.hasTotalRow && 'row-collapsable__total-row'
			],style:({
				'--header-height': `${_vm.headerHeight}px`
			})},[_c('ul',{directives:[{name:"maxHeight",rawName:"v-maxHeight",value:(_vm.offset),expression:"offset"}],staticClass:"row-collapsable__body",style:({
					...(_vm.minHeight && { 'min-height': `${_vm.minHeight}px` })
				}),attrs:{"data-testid":"row-collapsable-data"}},[_c('li',{ref:"tableHeader",staticClass:"row-collapsable__tr row-collapsable__thead"},[(_vm.allowExpand)?_c('ButtonIcon',{class:[
							'row-collapsable__icon-expand-collapse row-collapsable__icon-header',
							_vm.isOpenClass
						],attrs:{"iconClassName":"icon-arrow_right_filled","variant":"rotate","data-testid":"row-collapsable-allowExpand","disabled":_vm.showNoResults},on:{"click":function($event){return _vm.onExpandAllClick()}}}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasCheckbox),expression:"hasCheckbox"}],staticClass:"row-collapsable__checkbox-container"},[_c('Checkbox',{ref:"selectAllCheckbox",staticClass:"row-collapsable__checkbox",attrs:{"data-id":"row-collapsable-select-all","value":_vm.isCheckedSelectAll || this.allSelected,"indeterminate":_vm.checkboxIndeterminate,"disabled":_vm.showNoResults || this.allDisabled},on:{"change":_vm.onSelectAll}})],1),_c('div',{staticClass:"row-collapsable__data-container"},_vm._l((_vm.displayColumns),function(column,index){return _c('li',{key:column.columnName,class:[
								'row-collapsable__th',
								column.columnModifierName !== undefined &&
									'row-collapsable__th--' +
										column.columnModifierName,
								!column.isSortable && 'no-sortable'
							],attrs:{"tabindex":"0"},on:{"click":function($event){column.isSortable
									? _vm.handleSort(
											_vm.ascending,
											column.columnName,
											index,
											column.sortDirection,
											column.isSortable
									  )
									: null}}},[_c('div',{staticClass:"row-collapsable__data-header"},[_c('div',{staticClass:"row-collapsable__display-name"},[_c('span',{class:[
											'row-collapsable__display-name--' +
												column.columnModifierName
										]},[_vm._v(" "+_vm._s(column.columnDisplayName)+" ")]),(column.isSortable)?_c('div',{staticClass:"row-collapsable__sort-action"},[_c('i',{class:[
												'icon',
												_vm.sortDirectionClasses(
													column.sortDirection
												)
											],attrs:{"data-testid":"row-collapsable-isSorteable"}})]):_vm._e()])])])}),0)],1),_vm._l((_vm.internalRecordset),function(record,index){return _c('li',{key:record.$id,staticClass:"row-collapsable__tr"},[_c('div',{staticClass:"row-collapsable__data-group"},[_c('div',{staticClass:"row-collapsable__tr"},[(_vm.allowExpand)?_c('ButtonIcon',{class:[
									'row-collapsable__icon-expand-collapse',
									_vm.itemsExpanded[record.$id] && 'is-open'
								],attrs:{"iconClassName":"icon-arrow_right_filled","variant":"rotate","data-testid":"row-collapsable-expand"},on:{"click":function($event){return _vm.onExpandClick(record)}}}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasCheckbox),expression:"hasCheckbox"}],staticClass:"row-collapsable__checkbox-container",on:{"mouseenter":function($event){return _vm.onCheckboxMouseEnter(
										record,
										`singleSelectCheckbox${record[_vm.idColumn]}`
									)},"mouseleave":function($event){return _vm.onCheckboxMouseLeave(
										record,
										`singleSelectCheckbox${record[_vm.idColumn]}`
									)}}},[_c('Checkbox',{ref:`singleSelectCheckbox${record[_vm.idColumn]}`,refInFor:true,staticClass:"row-collapsable__checkbox",attrs:{"data-id":"row-collapsable-single-select","value":record.selected,"disabled":record.disabled},on:{"change":value => {
											_vm.onSelect(value, record[_vm.idColumn]);
										}}})],1),_vm._t("checkboxContent",null,{"record":record}),_c('div',{staticClass:"row-collapsable__data-container"},_vm._l((_vm.displayColumns),function(column){return _c('div',{key:column.columnName,staticClass:"row-collapsable__td",class:'row-collapsable__td--' +
											column.columnModifierName},[_vm._t(column.slot,function(){return [_c(column.component
													? column.component.name
													: 'span',_vm._g(_vm._b({tag:"component"},'component',
												column.component &&
												column.component.props
													? column.component.props(
															record,
															column,
															_vm.dynamicComponentEventHandler
													  )
													: {
															class: [
																'row-collapsable__data',
																'row-collapsable__data--' +
																	column.columnModifierName
															]
													  }
											,false),
												column.component &&
												column.component.events
													? column.component.events(
															record,
															column,
															_vm.dynamicComponentEventHandler
													  )
													: {}
											),[_vm._v(_vm._s(record[column.columnName]))])]},{"record":_vm.internalRecordset[index]})],2)}),0)],2),(
								record[_vm.childRecordsetPropName] &&
									_vm.itemsExpanded[record.$id]
							)?_c('div',{staticClass:"row-collapsable__nested",attrs:{"data-testid":"nested-slot"}},[_vm._t("nestedRowHeader",null,{"records":record}),_vm._t("nestedRow",function(){return [_vm._v(" "+_vm._s(record[_vm.childRecordsetPropName])+" ")]},{"records":record[_vm.childRecordsetPropName]})],2):_vm._e()])])}),(_vm.showNoResults)?_c('li',[_c('NoResultsMessage',{attrs:{"visible":true,"primaryTextCondensed":_vm.noResultsPrimaryText,"secondaryTextCondensed":_vm.noResultsSecondaryText}})],1):_vm._e()],2)]),(_vm.hasTotalRow)?_c('footer',{staticClass:"row-collapsable__footer",attrs:{"data-testid":"row-collapsable-footer"}},[_vm._t("rowCollapsableFooter")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }